import { supabase } from '../clients/supabaseClient';

export type PickingDashboardOrder = {
    order_id: string;
    order_reference: string;
    store_id: string;
    total_items: number;
    picker_id: string | null;
    picker_name: string;
    assigned_at: string | null;
    started_at: string | null;
    time_budget_seconds: number;
    elapsed_seconds: number | null;
    is_started: boolean;
    is_overdue: boolean;
    items_picked: number;
    items_required: number;
};

// Fetches the current picking dashboard state via the 'get-picking-dashboard' Edge Function.
// Uses an Edge Function rather than a direct table query because the dashboard requires
// complex joins across orders, picking_sessions, picking_session_items, pickers, and
// picking_time_settings to compute derived fields like elapsed_seconds, is_overdue,
// and items_picked — logic that would be expensive and fragile to replicate client-side.
export async function fetchPickingDashboard(): Promise<PickingDashboardOrder[]> {
    const { data, error } = await supabase.functions.invoke('get-picking-dashboard', {
        body: {},
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return (data?.orders ?? []) as PickingDashboardOrder[];
}